import { Link } from "react-router-dom";
import { ProfileCard } from "@/components/ProfileCard";
import { BrokerageCard } from "@/components/BrokerageCard";
import { useAuth } from "@/auth/AuthProvider";
import { hasCapability } from "@/lib/brokerAuth";

// Broker profile + brokerage (BRK-S019). On the post-login surface, a broker
// sees their own profile (editable by all) and their brokerage (editable only by
// an owner — brokerage:edit). The edit affordance is driven by the capabilities
// from GET /api/broker/me (PMS-S060); the server enforces the same rule.
export function ProfilePage() {
  const { identity } = useAuth();
  const canEditBrokerage = hasCapability(identity, "brokerage:edit");

  return (
    <section className="mx-auto flex w-full max-w-2xl flex-col gap-6 py-8">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-bold tracking-tight">
          Profile &amp; brokerage
        </h1>
        <p className="text-brk-dim">
          Manage your contact details and your brokerage's information.
        </p>
      </div>

      <ProfileCard />
      <BrokerageCard canEdit={canEditBrokerage} />

      <Link to="/portal" className="text-sm text-brk-accent hover:underline">
        ← Back to portal
      </Link>
    </section>
  );
}
